<template>
  <div
    class="text-text-warning-accent relative ml-1.5 flex items-center space-x-3"
  >
    <LocationIcon class="bg-background-neutral-secondary" />
    <p class="text-sm">
      {{
        t('warnings.stopLocation', {
          city: location.city,
          duration: location.duration,
        })
      }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import messages from '../../config/locales.json';
  import type { MappedSegmentStopLocation } from '../../types';
  import LocationIcon from '../../../../assets/images/location-icon.svg?component';

  const { t } = useI18n({ messages });

  defineProps<{
    location: MappedSegmentStopLocation;
  }>();
</script>
